import './styles.css';
import './i18n';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ApiError, onUnauthorized } from './lib/api';
import { meQuery } from './lib/session';
import { createAppRouter } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Ошибки доступа и валидации не лечатся повтором.
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});
const router = createAppRouter(queryClient);

// Сессия истекла или отозвана — на вход.
onUnauthorized(() => {
  queryClient.removeQueries({ queryKey: meQuery.queryKey });
  if (router.state.location.pathname !== '/login') void router.navigate({ to: '/login' });
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
